import type { NavItem } from '@/types'

export const PRIMARY_NAV: Array<NavItem> = [
    { label: 'Advisors', href: '/advisors' },
    { label: 'What we do', href: '/what-we-do' },
    { label: 'AI Intelligence', href: '/ai-intelligence' },
    { label: 'Tools', href: '/tools' }
]

export const SECONDARY_NAV: Array<NavItem> = [
    { label: 'Pricing', href: '/pricing' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' }
]

export const FOOTER_COLUMNS: Array<{ title: string, links: Array<NavItem> }> = [
    {
        title: 'Product',
        links: [
            { label: 'The AI advisor', href: '/ai-intelligence' },
            { label: 'Our services', href: '/what-we-do' },
            { label: 'Money calculators', href: '/tools' },
            { label: 'Plans and pricing', href: '/pricing' }
        ]
    },
    {
        title: 'Advisors',
        links: [
            { label: 'Meet the advisors', href: '/advisors' },
            { label: 'Get matched', href: '/find-an-advisor' },
            { label: 'Try the AI demo', href: '/ai-intelligence#demo' }
        ]
    },
    {
        title: 'Company',
        links: [
            { label: 'About Verdane', href: '/about' },
            { label: 'Get in touch', href: '/contact' },
            { label: 'Member sign in', href: '/login' },
            { label: 'Open an account', href: '/login?mode=signup' }
        ]
    },
    {
        title: 'Legal',
        links: [
            { label: 'Privacy policy', href: '/privacy' },
            { label: 'Terms of use', href: '/terms' },
            { label: 'Data security', href: '/ai-intelligence#privacy' },
            { label: 'Investment disclosures', href: '/terms#disclosures' }
        ]
    }
]
